import { render, staticRenderFns } from "./RecogidaIndumentarias.vue?vue&type=template&id=67688508"
import script from "./RecogidaIndumentarias.vue?vue&type=script&setup=true&lang=js"
export * from "./RecogidaIndumentarias.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports